import { render, staticRenderFns } from "./test-details.vue?vue&type=template&id=79dde33a"
import script from "./test-details.vue?vue&type=script&lang=js"
export * from "./test-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports